'use client';

import type { ICollectionPipelineStatusV3 } from '@repo/sdk';
import type { JSX } from 'react';
import { PipelineStepCell } from '../pipeline-step-cell';
import { PipelineStepDialog } from '../pipeline-step-dialog';
import { PipelineStepRejectedBadge } from '../pipeline-step-rejected-badge';

interface IRejectedClipStepProps {
  item: ICollectionPipelineStatusV3;
}

export function RejectedClipStep({ item }: IRejectedClipStepProps): JSX.Element {
  const { clipsRejected } = item.steps;

  return (
    <PipelineStepCell
      badge={<PipelineStepRejectedBadge count={clipsRejected.clip} />}
      renderDialog={(open, onOpenChange) => (
        <PipelineStepDialog
          open={open}
          onOpenChange={onOpenChange}
          title="Rejected clips"
          description={`${clipsRejected.clip} clip(s) rejected (challenge still active). Subtracted from the Uploaded and Published totals so those bars can reach 100%.`}
          dataHref={`/sys/challenges?collectionId=${item.collectionId}&triageAction=rejected`}
          dataLabel="Open rejected clips"
        />
      )}
    />
  );
}
